import {HIDE_EQUEUES_SNACKBAR, SHOW_EQUEUES_SNACKBAR} from "./types";

export const showEqueuesSnackBar = () => {
    return {
        type: SHOW_EQUEUES_SNACKBAR
    }
}

export const hideEqueuesSnackBar = () => {
    return {
        type: HIDE_EQUEUES_SNACKBAR
    }
}